import gql from 'graphql-tag';

export default gql`
    mutation UpdateActiveForJobSummary($input: UpdateActiveForJobSummaryInput) {
        updateActiveForJobSummary(input: $input) {
            message
        }
    }
`;
